import { render, staticRenderFns } from "./UpdateRep.vue?vue&type=template&id=72cdbde6&scoped=true&"
import script from "./UpdateRep.vue?vue&type=script&lang=js&"
export * from "./UpdateRep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cdbde6",
  null
  
)

export default component.exports